import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Spinner,
} from "react-bootstrap";
import { Link,useHistory } from "react-router-dom";
import axios from "axios";
import Baseurl from "../../../Baseurl";
function Products() {
  const [data, setData] = useState([]);
  const sort = 5;
  const history=useHistory()
  const activePag = useRef(0);
  const [itemDetails, setItemDetails] = useState([]);
  const [searchItemDetails, setSearchItemDetails] = useState([]);
  const [spinner, setSpinner] = useState(true);
  function getStaffData() {
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/item/get-all-item-details`)
      .then((res) => {
        console.log("categoiryeueye", res.data.details);
        setSpinner(false);
        setSearchItemDetails(res.data.details);
        setItemDetails(res.data.details);
        setData(document.querySelectorAll("#job_data tbody tr"))
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getStaffData();
  }, []);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchRider(value) {
    let filteredData = [];
    searchItemDetails.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setItemDetails(filteredData);
  }
  


  return (
    <Col lg={12}>
      <Card style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}>
        <Card.Header>
        <div>
            <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            />
          </div>
          <div>
          <button className="btn btn-primary" onClick={()=>{history.push("/Product-Managment")}}>Add New Product</button>

          </div>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              
              <Table responsive className="table text-white">
                <thead>
                  <tr>
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th>
                      <strong>NAME</strong>
                    </th>
                    <th>
                      <strong>Category</strong>
                    </th>
                    <th>
                      <strong>Sub category</strong>
                    </th>
                    <th>
                      <strong>Quantity</strong>
                    </th>
                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {itemDetails.map((val, key) => (
                    <tr>
                      <td><img 
                           alt=""
                           src={val.Image[0]                         }
                           height={60}
                           width={60}
                      /></td>
                      <td>{val.Name}</td>
                      <td>{val.CategoryId.Name}</td>
                      <td>{val.SubCategoryId.Name}</td>
                      <td>{`${val.UnitNumber}${val.Unit}`}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="warning"
                            className="light sharp i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>{" "}
                          <Dropdown.Menu>
                            <Dropdown.Item
                            onClick={()=>{history.push("/Product-Managment",val)}}
                            >
                              Update
                            </Dropdown.Item>
                          
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Products;
